module.exports = __webpack_public_path__ + "assets/img/Discover-Massage-Australia-eBook.fc886c45.jpg";